import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api";
import { Scanner } from "@yudiel/react-qr-scanner";
import { DEFAULT_PRELEVEMENT_ENTITE, PRELEVEMENT_ENTITES } from "./prelevementEntites";

import { useI18n } from "../i18n/I18nContext";

function normalizeText(text) {
  return text.toString().toLowerCase().normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, " ").trim();
}
function toFloat(v) {
  if (v === null || v === undefined || v === "") return 0;
  return Number(v.toString().replace(",", ".")) || 0;
}
function isAndroid() { return /Android/i.test(navigator.userAgent || ""); }

export default function PrelevementMelangeAmorceur() {
  const { t, ui } = useI18n();

  const navigate = useNavigate();

  const [operator, setOperator]               = useState("");
  const [entite, setEntite]                   = useState(DEFAULT_PRELEVEMENT_ENTITE);
  const [pns, setPns]                         = useState([]);
  const [pn, setPn]                           = useState("");
  const [pnSearch, setPnSearch]               = useState("");
  const [showPnList, setShowPnList]           = useState(false);
  const [qtyAmorceurKg, setQtyAmorceurKg]     = useState("");
  const [qtyEauKg, setQtyEauKg]               = useState("");
  const [qtyMelangeFinal, setQtyMelangeFinal] = useState("");
  const [temperature, setTemperature]         = useState("");
  const [pctNitrate, setPctNitrate]           = useState("");
  const [dureeRepos, setDureeRepos]           = useState("");
  const [solutionParcNumber, setSolutionParcNumber] = useState("");
  const [commentSolution, setCommentSolution] = useState("");
  const [now, setNow]                         = useState(new Date());
  const [loadingPn, setLoadingPn]             = useState(false);
  const [sending, setSending]                 = useState(false);
  const [printing, setPrinting]               = useState(false);
  const [error, setError]                     = useState("");
  const [success, setSuccess]                 = useState("");
  const [isScannerOpen, setIsScannerOpen]     = useState(false);
  const pnBoxRef                              = useRef(null);

  useEffect(() => {
    const raw = localStorage.getItem("user");
    if (raw) { try { setOperator(JSON.parse(raw).username || ""); } catch (e) { console.error(e); } }
  }, []);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    function handleClickOutside(e) { if (pnBoxRef.current && !pnBoxRef.current.contains(e.target)) setShowPnList(false); }
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => { document.removeEventListener("mousedown", handleClickOutside); document.removeEventListener("touchstart", handleClickOutside); };
  }, []);

  useEffect(() => {
    async function loadPn() {
      setLoadingPn(true); setError("");
      try {
        const res  = await apiFetch("/api/amorceur/list");
        if (!res.ok) throw new Error("Erreur API");
        const data = await res.json();
        const allPn = Array.isArray(data) ? data.map((item) => item.PN || item.pn).filter(Boolean) : [];
        setPns(Array.from(new Set(allPn)));
      } catch (err) { console.error(err); setError("Impossible de charger la liste des PN."); }
      finally { setLoadingPn(false); }
    }
    loadPn();
  }, []);

  const filteredPns = pns.filter((p) => {
    const s = normalizeText(pnSearch);
    return !s || normalizeText(p).includes(s);
  });

  function handleCreateParcNumber() {
    if (!pn) { alert("Merci de sélectionner un PN Amorceur d'abord."); return; }
    const firstPart = pn.split("_")[0];
    const A = toFloat(qtyAmorceurKg), E = toFloat(qtyEauKg), T = toFloat(temperature), N = toFloat(pctNitrate);
    const d = new Date();
    const dateStr = d.getFullYear() + String(d.getMonth() + 1).padStart(2, "0") + String(d.getDate()).padStart(2, "0");
    setSolutionParcNumber(`AMO_${firstPart}_A${A}_E${E}_T${T}_N${N}_${dateStr}`);
  }

  async function clientPrintFromApi(bodyForApi) {
    const win = window.open("", "_blank");
    if (win) { win.document.write(`<!doctype html><title>Préparation…</title><body>Préparation…</body>`); win.document.close(); }
    const res = await apiFetch("/api/labels/a4", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ...bodyForApi, format: "PNG", download: false }) });
    if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.message || `HTTP ${res.status}`); }
    const blob     = await res.blob();
    const blobUrl  = URL.createObjectURL(blob);
    const safePN   = String(bodyForApi.pn || "QR").replace(/[^\w\-]+/g, "_").slice(0, 64);
    const fileName = `A4_${bodyForApi.n || 1}x_${safePN}.png`;
    if (!win) { const a = document.createElement("a"); a.href = blobUrl; a.download = fileName; a.click(); URL.revokeObjectURL(blobUrl); return; }
    const AND = isAndroid();
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>${fileName}</title>
    <style>html,body{height:100%;margin:0}
    #bar{position:fixed;inset:auto 0 0 0;background:#111;color:#fff;padding:8px;display:flex;gap:8px;align-items:center;z-index:10}
    #bar button,#bar a{background:#E6FF3E;color:#000;border:0;padding:8px 12px;font-weight:800;cursor:pointer;text-decoration:none}
    .v{position:fixed;left:0;right:0;top:0;bottom:44px;width:100%;object-fit:contain;background:#fff}
    </style></head><body>
    <img class="v" src="${blobUrl}" alt=""/>
    <div id="bar">
      ${AND ? "" : "<button id='btnPrint'>Imprimer</button>"}
      <a href="${blobUrl}" download="${fileName}">Télécharger</a>
      <button id="btnClose">Fermer</button>
    </div>
    <script>
      ${AND ? "" : "btnPrint.onclick=()=>{try{window.focus();window.print();}catch(e){}};"}
      btnClose.onclick=()=>{try{URL.revokeObjectURL('${blobUrl}');}catch(e){};setTimeout(()=>window.close(),100);};
      window.onafterprint=()=>{try{URL.revokeObjectURL('${blobUrl}');}catch(e){};setTimeout(()=>window.close(),200);};
      ${AND ? "" : "setTimeout(()=>{try{window.focus();window.print();}catch(e){}},400);"}
    </script></body></html>`;
    win.document.open(); win.document.write(html); win.document.close();
  }

  async function handlePrintSolution() {
    if (!solutionParcNumber) { alert("Merci de créer le Parc number solution d'abord."); return; }
    try {
      setPrinting(true);
      await clientPrintFromApi({ n: 2, pn: solutionParcNumber, detail: `Mélange Amorceur ${pn || ""}`.trim(), date: new Date().toISOString().split("T")[0] });
      setSuccess("✅ Étiquette solution générée.");
    } catch (e) { setError(e.message || "Erreur impression"); }
    finally { setPrinting(false); }
  }

  async function handleSubmit(e) {
    e.preventDefault(); setError(""); setSuccess("");
    if (!pn) { setError("Merci de renseigner un lot Amorceur (PN)."); return; }
    handleCreateParcNumber();
    const payload = {
      operator, entite, pn,
      qtyAmorceurKg: toFloat(qtyAmorceurKg), qtyEauKg: toFloat(qtyEauKg),
      qtyMelangeFinal: toFloat(qtyMelangeFinal),
      temperature: toFloat(temperature), pctNitrate: toFloat(pctNitrate),
      dureeRepos: Number(dureeRepos) || 0,
      solutionParcNumber: solutionParcNumber || "",
      commentSolution: commentSolution || "",
      timestamp: new Date().toISOString(),
    };
    try {
      setSending(true);
      const res = await apiFetch("/api/production/amorceur-melange", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
      if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.message || "Erreur serveur"); }
      setQtyAmorceurKg(""); setQtyEauKg(""); setQtyMelangeFinal("");
      setTemperature(""); setPctNitrate(""); setDureeRepos("");
      setCommentSolution("");
      setSuccess("✅ Données enregistrées avec succès.");
    } catch (err) { setError("❌ " + (err.message || "Erreur lors de l'envoi.")); }
    finally { setSending(false); }
  }

  const timeStr = now.toLocaleTimeString("fr-FR");
  const dateStr = now.toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });

  return (
    <div className="pma-page">
      <div className="pma-card">

        {/* HEADER */}
        <div className="pma-header">
          <span>Prélèvement & Mélange Amorceur</span>
          <span className="pma-header-sub">Préparation de la solution d'amorçage</span>
        </div>

        {/* NAV */}
        <div className="pma-nav">
          <button type="button" className="pma-btn-back" onClick={() => navigate("/menu")}>← Retour menu</button>
          <div className="pma-clock">
            <div className="pma-clock-time">{timeStr}</div>
            <div className="pma-clock-date">{dateStr}</div>
          </div>
        </div>

        {/* OPÉRATEUR */}
        <div className="pma-operator">
          <span className="pma-operator-dot" />
          {operator ? operator.toUpperCase() : "OPÉRATEUR NON CONNECTÉ"}
        </div>

        <form onSubmit={handleSubmit} className="pma-form">

          <div className="pma-section">
            <div className="pma-section-label">🏢 Entité qui prélève</div>
            <div className="pma-entite-row">
              {PRELEVEMENT_ENTITES.map((opt) => (
                <button
                  key={opt}
                  type="button"
                  className={`pma-entite-btn ${entite === opt ? "pma-entite-active" : ""}`}
                  onClick={() => setEntite(opt)}
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>

          {/* PN AMORCEUR */}
          <div className="pma-section">
            <div className="pma-section-label pma-label-pink">🧪 Lot Amorceur — Parc Number</div>
            <div ref={pnBoxRef} style={{ position: "relative" }}>
              <div className="pma-select-row">
                <input value={pnSearch}
                  onChange={(e) => { setPnSearch(e.target.value); setShowPnList(true); }}
                  onFocus={() => setShowPnList(true)}
                  placeholder={loadingPn ? "Chargement…" : "Sélectionner un PN Amorceur"}
                  disabled={loadingPn}
                  className="pma-select-input" />
                <button type="button" className="pma-scan-btn" onClick={() => setIsScannerOpen(true)} title="Scanner QR">📷</button>
              </div>
              {pn && (
                <div className="pma-selected-badge">
                  <span>✔</span><strong>{pn}</strong>
                  <button type="button" className="pma-clear-btn" onClick={() => { setPn(""); setPnSearch(""); }}>✕</button>
                </div>
              )}
              {showPnList && filteredPns.length > 0 && (
                <div className="pma-dropdown" onMouseDown={(e) => e.preventDefault()}>
                  {filteredPns.map((p) => (
                    <div key={p} className="pma-dropdown-item"
                      onClick={() => { setPn(p); setPnSearch(p); setShowPnList(false); }}>{p}</div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* QUANTITÉS AMORCEUR + EAU */}
          <div className="pma-grid-2">
            <div className="pma-section pma-section-pink">
              <div className="pma-section-label pma-label-pink">🧴 Amorceur</div>
              <div className="pma-field-sub">Quantité (kg)</div>
              <input type="text" inputMode="decimal" value={qtyAmorceurKg}
                onChange={(e) => setQtyAmorceurKg(e.target.value.replace(/[^0-9.,]/g, ""))}
                className="pma-num-input" placeholder="Ex: 12.5" />
            </div>
            <div className="pma-section pma-section-pink">
              <div className="pma-section-label pma-label-pink">💧 Eau d'amorceur</div>
              <div className="pma-field-sub">Quantité (kg)</div>
              <input type="text" inputMode="decimal" value={qtyEauKg}
                onChange={(e) => setQtyEauKg(e.target.value.replace(/[^0-9.,]/g, ""))}
                className="pma-num-input" placeholder="Ex: 5.0" />
            </div>
          </div>

          {/* MÉLANGE FINAL */}
          <div className="pma-section pma-section-yellow">
            <div className="pma-section-label pma-label-yellow">⚖️ Quantité mélange finale (kg)</div>
            <input type="text" inputMode="decimal" value={qtyMelangeFinal}
              onChange={(e) => setQtyMelangeFinal(e.target.value.replace(/[^0-9.,]/g, ""))}
              className="pma-num-input pma-num-final" placeholder="Ex: 17.5" />
          </div>

          {/* PARAMÈTRES PROCESS */}
          <div className="pma-section">
            <div className="pma-section-label">⚙️ Paramètres process</div>
            <div className="pma-grid-3">
              <div className="pma-param-col">
                <div className="pma-param-label">Température (°C)</div>
                <input type="text" inputMode="decimal" value={temperature}
                  onChange={(e) => setTemperature(e.target.value.replace(/[^0-9.,]/g, ""))}
                  className="pma-num-input" placeholder="Ex: 25" />
              </div>
              <div className="pma-param-col">
                <div className="pma-param-label">% Nitrate ammonium</div>
                <input type="text" inputMode="decimal" value={pctNitrate}
                  onChange={(e) => setPctNitrate(e.target.value.replace(/[^0-9.,]/g, ""))}
                  className="pma-num-input" placeholder="Ex: 8.5" />
              </div>
              <div className="pma-param-col">
                <div className="pma-param-label">Durée de repos (min)</div>
                <input type="number" value={dureeRepos}
                  onChange={(e) => setDureeRepos(e.target.value)}
                  className="pma-num-input" placeholder="Ex: 30" />
              </div>
            </div>
          </div>

          {/* PARC NUMBER SOLUTION + PRINT */}
          <div className="pma-section pma-section-solution">
            <div className="pma-section-label pma-label-red">🏷 Parc Number Solution</div>
            <div className="pma-solution-row">
              <button type="button" onClick={handleCreateParcNumber} className="pma-btn-create-pn">
                ⚡ Créer Parc number solution
              </button>
              <button type="button" onClick={handlePrintSolution}
                disabled={!solutionParcNumber || printing}
                className="pma-btn-print-pn">
                {printing ? "⏳" : "🖨 Print"}
              </button>
            </div>
            <input value={solutionParcNumber} readOnly
              placeholder="Parc number solution généré automatiquement…"
              className={`pma-pn-display ${solutionParcNumber ? "pma-pn-filled" : ""}`} />
            <div className="pma-field-sub pma-label-orange">💬 Commentaires / paramètres</div>
            <textarea rows={3} value={commentSolution}
              onChange={(e) => setCommentSolution(e.target.value)}
              className="pma-textarea"
              placeholder="Observations, paramètres complémentaires…" />
          </div>

          {/* MESSAGES */}
          {error   && <div className="pma-msg pma-msg-error">{error}</div>}
          {success && <div className="pma-msg pma-msg-success">{success}</div>}

          {/* SUBMIT */}
          <div className="pma-submit-row">
            <button type="submit" disabled={sending} className="pma-btn-submit">
              {sending ? "⏳ Envoi en cours…" : "✔ OK confirmation et envoi"}
            </button>
            <button type="button" className="pma-btn-time">
              Time
              <div className="pma-btn-time-sub">{timeStr}</div>
            </button>
          </div>

        </form>
      </div>

      {/* SCANNER */}
      {isScannerOpen && (
        <div className="pma-modal-backdrop" onClick={() => setIsScannerOpen(false)}>
          <div className="pma-modal-scanner" onClick={(e) => e.stopPropagation()}>
            <div className="pma-modal-title">📷 Scanner QR code Amorceur</div>
            <div style={{ borderRadius: 10, overflow: "hidden" }}>
              <Scanner
                onScan={(codes) => {
                  if (!codes?.length) return;
                  const text = codes[0]?.rawValue;
                  if (!text) return;
                  setPn(text); setPnSearch(text); setShowPnList(false); setIsScannerOpen(false);
                }}
                onError={console.error}
                constraints={{ facingMode: "environment" }}
              />
            </div>
            <button type="button" className="pma-btn-close-scanner" onClick={() => setIsScannerOpen(false)}>✕ Fermer</button>
          </div>
        </div>
      )}

      <Style />
    </div>
  );
}

/* ── STYLES ── */
function Style() {
  return (
    <style>{`
      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

      .pma-page {
        min-height: 100vh; width: 100%;
        background: radial-gradient(ellipse at top,#01283a 0%,#010F14 70%);
        display: flex; justify-content: center; align-items: flex-start;
        padding: 16px; font-family: 'Inter','Segoe UI',sans-serif;
      }
      .pma-card {
        width: 100%; max-width: 680px;
        background: #011e2b; border: 1px solid #1a4a5a;
        border-radius: 16px; overflow: hidden;
        box-shadow: 0 8px 40px rgba(0,0,0,0.6), 0 0 0 1px #0a3040;
      }

      /* HEADER */
      .pma-header {
        background: linear-gradient(135deg,#E6FF3E,#c8e800);
        color: #000; padding: 14px 20px;
        display: flex; flex-direction: column; align-items: center; gap: 2px;
      }
      .pma-header span   { font-size: 14px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; text-align: center; }
      .pma-header-sub    { font-size: 11px; font-weight: 500; opacity: 0.6; }

      /* NAV */
      .pma-nav {
        background: #010f14; padding: 8px 16px;
        display: flex; justify-content: space-between; align-items: center;
        border-bottom: 1px solid #1a4a5a;
      }
      .pma-btn-back {
        background: transparent; color: #7ab8cc;
        border: 1px solid #1a4a5a; border-radius: 6px;
        padding: 5px 10px; font-size: 11px; font-weight: 600; cursor: pointer; transition: all 0.2s;
      }
      .pma-btn-back:hover { background: #1a4a5a; color: #fff; }
      .pma-clock          { text-align: right; }
      .pma-clock-time     { color: #E6FF3E; font-size: 15px; font-weight: 700; font-variant-numeric: tabular-nums; }
      .pma-clock-date     { color: #5a8a99; font-size: 10px; }

      /* OPÉRATEUR */
      .pma-operator {
        display: flex; align-items: center; gap: 10px;
        background: linear-gradient(90deg,#012836,#013d50);
        border: 1px solid #1a5a6a; border-radius: 10px;
        margin: 14px 20px 0; padding: 12px 16px;
        color: #fff; font-size: 14px; font-weight: 700; letter-spacing: 0.06em;
      }
      .pma-operator-dot { width: 10px; height: 10px; background: #00B050; border-radius: 50%; box-shadow: 0 0 6px #00B050; flex-shrink: 0; }

      /* FORM */
      .pma-form { padding: 16px 20px 24px; display: flex; flex-direction: column; gap: 14px; overflow-y: auto; flex: 1; }

      /* SECTIONS */
      .pma-section {
        background: #012030; border: 1px solid #1a4a5a;
        border-radius: 12px; padding: 14px 16px;
        display: flex; flex-direction: column; gap: 10px;
      }
      .pma-section-pink     { border-color: #8B0000; background: #1a0820; }
      .pma-section-yellow   { border-color: #FFD966; background: #1a1400; align-items: center; }
      .pma-section-solution { border-color: #C00000; background: #1a0808; }
      .pma-section-label    { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #7ab8cc; }
      .pma-entite-row { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }
      .pma-entite-btn {
        background: #012030; color: #7ab8cc; border: 1px solid #1a4a5a;
        border-radius: 8px; padding: 10px 8px; font-size: 13px; font-weight: 700;
        cursor: pointer; transition: all 0.15s;
      }
      .pma-entite-btn:hover { background: #1a4a5a; color: #fff; }
      .pma-entite-active { background: #E6FF3E; color: #000; border-color: #E6FF3E; }
      .pma-label-pink       { color: #E5A5D5; }
      .pma-label-yellow     { color: #FFD966; }
      .pma-label-red        { color: #ff9090; }
      .pma-label-orange     { color: #FFB366; }
      .pma-field-sub        { font-size: 11px; font-weight: 600; color: #7ab8cc; }

      /* GRIDS */
      .pma-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
      .pma-grid-3 { display: grid; grid-template-columns: repeat(3,1fr); gap: 10px; }

      /* SELECT ROW */
      .pma-select-row   { display: flex; gap: 8px; align-items: center; }
      .pma-select-input {
        flex: 1; background: #003818; color: #7aff9a;
        border: 1px solid #005020; border-radius: 8px;
        padding: 10px 14px; font-size: 14px; font-weight: 600;
        outline: none; transition: border 0.2s;
      }
      .pma-select-input:focus { border-color: #00B050; box-shadow: 0 0 0 2px rgba(0,176,80,0.15); }
      .pma-select-input:disabled { opacity: 0.6; cursor: not-allowed; }
      .pma-scan-btn {
        width: 46px; height: 46px; flex-shrink: 0; background: #012030;
        border: 1px solid #1a4a5a; border-radius: 8px;
        font-size: 20px; cursor: pointer; transition: background 0.2s;
      }
      .pma-scan-btn:hover { background: #1a4a5a; }
      .pma-selected-badge {
        display: flex; align-items: center; gap: 8px; margin-top: 6px;
        background: #002810; border: 1px solid #00B050; border-radius: 8px;
        padding: 5px 12px; font-size: 12px; color: #7aff9a;
      }
      .pma-selected-badge strong { flex: 1; font-size: 13px; }
      .pma-clear-btn { background: transparent; border: none; color: #ff8080; cursor: pointer; font-size: 14px; font-weight: 700; }
      .pma-dropdown {
        position: absolute; left: 0; right: 0; margin-top: 4px;
        max-height: 200px; overflow-y: auto;
        background: #002818; border: 1px solid #005020; border-radius: 8px; z-index: 50;
        box-shadow: 0 8px 24px rgba(0,0,0,0.5);
      }
      .pma-dropdown-item {
        padding: 8px 14px; color: #aaffcc; font-size: 13px;
        cursor: pointer; border-bottom: 1px solid #003818; transition: background 0.15s;
      }
      .pma-dropdown-item:hover { background: #003d20; }

      /* NUM INPUTS */
      .pma-num-input {
        width: 100%; background: #010f14; color: #fff;
        border: 1px solid #1a4a5a; border-radius: 8px;
        padding: 10px 12px; font-size: 18px; font-weight: 700; text-align: center;
        outline: none; transition: border 0.2s;
      }
      .pma-num-input:focus { border-color: #E6FF3E; box-shadow: 0 0 0 2px rgba(230,255,62,0.1); }
      .pma-num-final { font-size: 24px; max-width: 260px; background: #FFF2CC; color: #000; border-color: #FFD966; border-width: 2px; }
      .pma-num-final:focus { border-color: #C00000; }

      /* PARAM COLS */
      .pma-param-col   { display: flex; flex-direction: column; gap: 6px; }
      .pma-param-label { background: #F2F2F2; color: #000; border: 2px solid #C00000; border-radius: 8px; padding: 6px; text-align: center; font-weight: 700; font-size: 11px; }

      /* SOLUTION */
      .pma-solution-row { display: flex; gap: 8px; align-items: center; }
      .pma-btn-create-pn {
        flex: 1; background: #C00000; color: #fff; border: 2px solid #800000;
        border-radius: 8px; padding: 10px 12px; font-weight: 700; font-size: 13px;
        cursor: pointer; transition: opacity 0.2s;
      }
      .pma-btn-create-pn:hover { opacity: 0.85; }
      .pma-btn-print-pn {
        background: #FFD966; color: #000; border: 2px solid #C00000;
        border-radius: 8px; padding: 10px 16px; font-weight: 800; font-size: 13px;
        cursor: pointer; transition: opacity 0.2s; white-space: nowrap;
      }
      .pma-btn-print-pn:disabled { opacity: 0.5; cursor: not-allowed; }
      .pma-btn-print-pn:hover:not(:disabled) { opacity: 0.85; }
      .pma-pn-display {
        width: 100%; background: #1a2a2a; color: #7ab8cc; border: 1px dashed #3a6a7a;
        border-radius: 8px; padding: 10px 14px; font-size: 12px; font-family: monospace;
        cursor: not-allowed; outline: none; letter-spacing: 0.03em;
      }
      .pma-pn-filled { background: #012836; color: #7aff9a; border-color: #00B050; border-style: solid; }
      .pma-textarea {
        width: 100%; background: #EAC1A8; color: #000;
        border: 2px solid #C00000; border-radius: 8px;
        padding: 10px 12px; font-size: 13px; resize: vertical; outline: none;
        transition: border 0.2s; line-height: 1.5;
      }
      .pma-textarea:focus { border-color: #900000; }

      /* MESSAGES */
      .pma-msg         { border-radius: 8px; padding: 10px 14px; font-size: 13px; font-weight: 600; }
      .pma-msg-error   { background: #2a0808; border: 1px solid #C00000; color: #ff9090; }
      .pma-msg-success { background: #002810; border: 1px solid #00B050; color: #80ff90; }

      /* SUBMIT */
      .pma-submit-row  { display: flex; gap: 10px; align-items: center; }
      .pma-btn-submit  {
        flex: 1; background: linear-gradient(135deg,#00B050,#008a3c);
        color: #000; border: none; border-radius: 10px;
        padding: 14px; font-size: 15px; font-weight: 800;
        text-transform: uppercase; letter-spacing: 0.08em; cursor: pointer;
        transition: opacity 0.2s, transform 0.1s;
        box-shadow: 0 4px 16px rgba(0,176,80,0.3);
      }
      .pma-btn-submit:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
      .pma-btn-submit:disabled { opacity: 0.5; cursor: not-allowed; }
      .pma-btn-time {
        min-width: 110px; background: #C00000; color: #fff;
        border: 2px solid #7F0000; border-radius: 8px;
        padding: 8px 10px; font-weight: 700; font-size: 12px; cursor: default; text-align: center;
      }
      .pma-btn-time-sub { font-size: 11px; margin-top: 2px; font-variant-numeric: tabular-nums; }

      /* SCANNER MODAL */
      .pma-modal-backdrop {
        position: fixed; inset: 0; background: rgba(0,0,0,0.8);
        display: flex; justify-content: center; align-items: center;
        z-index: 999; backdrop-filter: blur(4px);
      }
      .pma-modal-scanner {
        width: 90%; max-width: 420px; background: #011e2b;
        border: 1px solid #00B050; border-radius: 14px; padding: 16px;
        display: flex; flex-direction: column; gap: 12px;
        box-shadow: 0 0 40px rgba(0,176,80,0.2);
      }
      .pma-modal-title { color: #fff; font-size: 14px; font-weight: 700; text-align: center; }
      .pma-btn-close-scanner {
        background: #C00000; color: #fff; border: none; border-radius: 8px;
        padding: 10px; font-weight: 700; font-size: 13px; cursor: pointer; transition: opacity 0.2s;
      }
      .pma-btn-close-scanner:hover { opacity: 0.85; }

      /* TABLETTE */
      @media (min-width: 768px) {
        .pma-card  { max-width: 820px; }
        .pma-header span { font-size: 17px; }
        .pma-form  { padding: 20px 28px 28px; gap: 18px; }
        .pma-select-input { font-size: 16px; padding: 12px 16px; }
        .pma-scan-btn     { width: 54px; height: 54px; font-size: 24px; }
        .pma-num-input    { font-size: 22px; padding: 12px; }
        .pma-num-final    { font-size: 28px; max-width: 320px; }
        .pma-param-label  { font-size: 12px; }
        .pma-btn-submit   { font-size: 16px; padding: 16px; }
      }

      /* DESKTOP */
      @media (min-width: 1024px) {
        .pma-card  { max-width: 960px; }
        .pma-header span { font-size: 20px; }
        .pma-form  { padding: 20px 36px 36px; gap: 20px; }
        .pma-operator { margin: 16px 36px 0; font-size: 16px; }
        .pma-section  { padding: 18px 20px; border-radius: 14px; }
        .pma-section-label { font-size: 13px; }
        .pma-select-input  { font-size: 18px; padding: 14px 18px; }
        .pma-num-input     { font-size: 26px; padding: 14px; }
        .pma-num-final     { font-size: 34px; max-width: 380px; }
        .pma-param-label   { font-size: 13px; padding: 8px; }
        .pma-btn-create-pn { font-size: 14px; padding: 12px 16px; }
        .pma-btn-print-pn  { font-size: 14px; padding: 12px 20px; }
        .pma-pn-display    { font-size: 13px; padding: 12px 16px; }
        .pma-textarea      { font-size: 14px; padding: 12px 16px; }
        .pma-btn-submit    { font-size: 18px; padding: 18px; border-radius: 12px; }
        .pma-btn-time      { min-width: 140px; }
      }

      /* XXL */
      @media (min-width: 1400px) {
        .pma-page  { padding: 32px; }
        .pma-card  { max-width: 1200px; border-radius: 20px; }
        .pma-header { padding: 24px 48px; }
        .pma-header span { font-size: 24px; letter-spacing: 0.12em; }
        .pma-header-sub  { font-size: 14px; }
        .pma-nav   { padding: 14px 36px; }
        .pma-clock-time  { font-size: 22px; }
        .pma-operator    { margin: 18px 48px 0; font-size: 20px; padding: 16px 24px; border-radius: 14px; }
        .pma-operator-dot { width: 14px; height: 14px; }
        .pma-form  { padding: 24px 48px 40px; gap: 24px; }
        .pma-section { padding: 22px 24px; border-radius: 16px; }
        .pma-section-label { font-size: 15px; letter-spacing: 0.1em; }
        .pma-select-input  { font-size: 22px; padding: 16px 20px; border-radius: 10px; height: 62px; }
        .pma-scan-btn      { width: 66px; height: 66px; font-size: 28px; border-radius: 10px; }
        .pma-dropdown-item { font-size: 15px; padding: 10px 18px; }
        .pma-grid-2        { gap: 18px; }
        .pma-grid-3        { gap: 14px; }
        .pma-num-input     { font-size: 30px; padding: 16px; border-radius: 10px; }
        .pma-num-final     { font-size: 42px; max-width: 440px; padding: 18px; border-radius: 12px; }
        .pma-param-label   { font-size: 14px; padding: 10px; border-radius: 10px; }
        .pma-solution-row  { gap: 12px; }
        .pma-btn-create-pn { font-size: 16px; padding: 14px 20px; border-radius: 10px; }
        .pma-btn-print-pn  { font-size: 16px; padding: 14px 24px; border-radius: 10px; }
        .pma-pn-display    { font-size: 15px; padding: 14px 18px; border-radius: 10px; }
        .pma-textarea      { font-size: 16px; padding: 14px 18px; border-radius: 10px; }
        .pma-msg           { font-size: 15px; padding: 14px 18px; border-radius: 10px; }
        .pma-btn-submit    { font-size: 22px; padding: 22px; border-radius: 14px; letter-spacing: 0.1em; }
        .pma-btn-time      { min-width: 170px; font-size: 14px; padding: 14px; border-radius: 10px; }
        .pma-btn-time-sub  { font-size: 13px; }
      }
    `}</style>
  );
}
